@if (radioForm) {
  <div class="specialist-selection-container">
    <app-info-box
      title="{{ 'steps.specialistSelection.type_consultation' | translate }}"
      description="{{ 'steps.specialistSelection.select_specialty' | translate }}"
    ></app-info-box>
    <div class="container-radio-elements" [formGroup]="radioForm">
      <nz-radio-group [formControlName]="'specialistType'">
        @for (radioElement of specialistSelection; track radioElement; let i = $index) {
          <div class="radio-element-container">
            <h2>{{ radioTitles[i] | translate }}</h2>
            <nz-divider></nz-divider>
            <div class="radio-element-list">
              @for (radioButton of radioElement; track radioButton; let j = $index) {
                <div>
                  <label nz-radio [nzValue]="radioButton">{{ radioLabels[i][j] | translate }}</label>
                </div>
              }
            </div>
          </div>
        }
      </nz-radio-group>
    </div>
  </div>
}
